"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sioc = exports.forgot_password_token = exports.has_owner = exports.usergroup_of = exports.name = exports.member_of = exports.links_to = exports.id = exports.has_usergroup = exports.has_scope = exports.has_member = exports.has_function = exports.has_creator = exports.email = exports.avatar = exports.account_of = exports.about = exports.Usergroup = exports.UserAccount = exports.Space = exports.Site = exports.Role = exports.Item = exports.Container = exports._self = exports.ns = exports.loadData = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
//finally, we pass on all the exports, plus the namespace, prefix and data loading function
// as we register this ontology in the LINCD tree
const _this = __importStar(require("./sioc"));
var loadData = () => JSONLD_1.JSONLD.parsePromise(Promise.resolve().then(() => __importStar(require('../data/sioc.json'))));
exports.loadData = loadData;
exports.ns = (0, NameSpace_1.createNameSpace)('http://rdfs.org/sioc/ns#');
//It's recommended to export a NamedNode for the ontology itself as well
exports._self = (0, exports.ns)('');
//The main goal though of this file is to export a reference to NamedNode with the correct URI
// for all the entities (Classes and properties) in the ontology
exports.Container = (0, exports.ns)('Container');
exports.Item = (0, exports.ns)('Item');
exports.Role = (0, exports.ns)('Role');
exports.Site = (0, exports.ns)('Site');
exports.Space = (0, exports.ns)('Space');
exports.UserAccount = (0, exports.ns)('UserAccount');
exports.Usergroup = (0, exports.ns)('Usergroup');
exports.about = (0, exports.ns)('about');
exports.account_of = (0, exports.ns)('account_of');
exports.avatar = (0, exports.ns)('avatar');
exports.email = (0, exports.ns)('email');
exports.has_creator = (0, exports.ns)('has_creator');
exports.has_function = (0, exports.ns)('has_function');
exports.has_member = (0, exports.ns)('has_member');
exports.has_scope = (0, exports.ns)('has_scope');
exports.has_usergroup = (0, exports.ns)('has_usergroup');
exports.id = (0, exports.ns)('id');
exports.links_to = (0, exports.ns)('links_to');
exports.member_of = (0, exports.ns)('member_of');
exports.name = (0, exports.ns)('name');
exports.usergroup_of = (0, exports.ns)('usergroup_of');
exports.has_owner = (0, exports.ns)('has_owner');
exports.forgot_password_token = (0, exports.ns)('forgot_password_token');
exports.sioc = {
    Container: exports.Container,
    Item: exports.Item,
    Role: exports.Role,
    Site: exports.Site,
    Space: exports.Space,
    UserAccount: exports.UserAccount,
    Usergroup: exports.Usergroup,
    about: exports.about,
    account_of: exports.account_of,
    avatar: exports.avatar,
    email: exports.email,
    has_creator: exports.has_creator,
    has_function: exports.has_function,
    has_member: exports.has_member,
    has_owner: exports.has_owner,
    has_scope: exports.has_scope,
    has_usergroup: exports.has_usergroup,
    id: exports.id,
    links_to: exports.links_to,
    member_of: exports.member_of,
    name: exports.name,
    usergroup_of: exports.usergroup_of,
    forgot_password_token: exports.forgot_password_token,
};
//as third parameter, provide a prefix (string) that can be used to refer to the full ontology URL.
//for example: 'schema' refers to https://www.schema.org/
(0, package_1.linkedOntology)(_this, exports.ns, 'sioc', exports.loadData, '../data/sioc.json');
//# sourceMappingURL=sioc.js.map